import { useCallback, useMemo } from 'react';

import { ISendAnnotationPayload, sendAnnotationThunk } from '../thunks/analytics-thunk';

import { useAppDispatch } from './app-hooks';
import { useSources } from './settings-hooks';

export type SendAnnotationParams = Omit<ISendAnnotationPayload, 'sources'>;

export const useAnalytics = () => {
    const dispatch = useAppDispatch();
    const { sources } = useSources();

    const sendAnnotation = useCallback(
        async (params: SendAnnotationParams) => {
            return dispatch(
                sendAnnotationThunk({
                    ...params,
                    sources,
                })
            );
        },
        [dispatch, sources]
    );

    return useMemo(() => [sendAnnotation] as const, [sendAnnotation]);
};
